import React from 'react'

const CustomRadioButton = ({ value, selectedValue, handleSelect }) => {
  const isSelected = value === selectedValue

  return (
    <button
      type="button"
      className="px-4 py-2 rounded-full font-medium transition-all"
      onClick={() => handleSelect(value)}
      style={{
        background: isSelected
          ? 'var(--button-bg)'
          : 'var(--button-secondary-bg)',
        border: isSelected
          ? 'none'
          : '1px solid var(--button-secondary-border)',
        color: isSelected
          ? 'var(--button-text)'
          : 'var(--button-secondary-text)'
      }}
    >
      {value}
    </button>
  )
}

export default CustomRadioButton
